module.exports = __webpack_public_path__ + "img/crew_timesheet.3084d95c.svg";